import { options } from '../config/options';
import { rgIDs } from '../../shared/constants/domIDs';
import { compactV2Url, zoidUrl } from '../../shared/constants/urls';

window.RGCompactV2Component = window.zoid.create({
  ...options,
  tag: rgIDs.compactV2,
  url: zoidUrl(compactV2Url),
  props: {
    ...options.props,
    onDispatchTriggerAttributes: {
      type: 'function',
      required: true,
    },
  },
});
